"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSmallBannerStyle = exports.createFullBannerStyle = exports.createBannerStyle = void 0;
var react_1 = require("@emotion/react");
var design_system_colors_1 = require("../../../style/theme/design-system-colors");
var variables_1 = require("../../../style/variables");
var CONTAINER_BORDER = {
    floating: {
        border: '1px solid' + design_system_colors_1.DesignSystemThemeColor.Primary.LIGHT_2,
        borderRadius: 12,
        boxShadow: "var(" + variables_1.Shadow.lg + ")",
    },
    sticky: {
        borderBottom: '1px solid' + design_system_colors_1.DesignSystemThemeColor.Primary.LIGHT_2,
    },
};
var createBannerStyle = function (type, size) { return ({
    container: react_1.css(__assign({ background: design_system_colors_1.DesignSystemThemeColor.Primary.LIGHT_6, minHeight: 60, padding: size === 'full' ? 12 : 16 }, CONTAINER_BORDER[type])),
    closeBtn: react_1.css({
        color: design_system_colors_1.DesignSystemThemeColor.Primary.DEFAULT,
    }),
    textContainer: react_1.css({
        flex: 1,
    }),
    centerAlignText: react_1.css({
        textAlign: 'center',
    }),
    primaryAction: react_1.css({}),
    secondaryAction: react_1.css({}),
}); };
exports.createBannerStyle = createBannerStyle;
var createFullBannerStyle = function () { return ({
    container: react_1.css({
        width: '100%',
    }),
    subText: react_1.css({ marginLeft: 6 }),
    closeBtn: react_1.css({
        height: 40,
        width: 40,
        marginLeft: 8,
        cursor: 'pointer',
        color: design_system_colors_1.DesignSystemThemeColor.Primary.DEFAULT,
    }),
    primaryAction: react_1.css({}),
    secondaryAction: react_1.css({ marginRight: 8 }),
}); };
exports.createFullBannerStyle = createFullBannerStyle;
var createSmallBannerStyle = function () { return ({
    container: react_1.css({
        width: 359,
    }),
    closeBtn: react_1.css({
        height: 40,
        width: 40,
        marginRight: -10,
        marginTop: -10,
        cursor: 'pointer',
        color: design_system_colors_1.DesignSystemThemeColor.Primary.DEFAULT,
    }),
    subText: react_1.css({ marginTop: 2 }),
    primaryAction: react_1.css({ width: '100%' }),
    secondaryAction: react_1.css({ width: '100%' }),
}); };
exports.createSmallBannerStyle = createSmallBannerStyle;
